// @copyright  2025 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    // Page titles
    'accrued-revenue.page.title': 'Accrued Revenues',
    'accrued_revenues.page_title': 'Accrued Revenues',
    'accrued-revenue.page.create.title': 'Create Accrued Revenue',
    'accrued_revenues.page.update.title': 'Update Accrued Revenue',
    'accrued-revenue.page.all': 'All Accrued Revenues',

    // Buttons
    'accrued-revenue.button.create': 'Create Accrued Revenue',
    'accrued-revenue.button.cancel': 'Cancel',
    'accrued-revenue.button.save': 'Save',
    'accrued_revenues.edit': 'Edit',

    // Labels
    'accrued-revenue.label.status': 'Status',
    'accrued_revenues.fields.accrual_number': 'Accrual Number',
    'accrued_revenues.fields.accrual_status': 'Status',
    'accrued_revenues.fields.accrual_date': 'Accrual Date',
    'accrued_revenues.fields.expected_billing_date': 'Expected Billing Date',
    'accrued_revenues.fields.entity': 'Entity',
    'accrued_revenues.fields.general_ledger_account': 'Revenue Account',
    'accrued_revenues.fields.accrued_receivable_account': 'Accrued Revenue Account',
    'accrued_revenues.fields.currency': 'Currency',
    'accrued_revenues.fields.amount': 'Amount',
    'accrued_revenues.fields.balance_outstanding': 'Balance Outstanding',
    'accrued_revenues.fields.description': 'Description',
    'accrued_revenues.fields.reference_number': 'Reference Number',
    'accrued_revenues.fields.memo': 'Memo',
    'accrued_revenues.fields.auto_reverse': 'Auto Reverse',
    'accrued_revenues.fields.reversal_date': 'Reversal Date',
    'accrued_revenues.fields.is_recurring': 'Is Recurring',
    'accrued_revenues.fields.is_reversed': 'Is Reversed',
    'accrued-revenue.label.accrual_date': 'Accrual Date',
    'accrued-revenue.label.expected_billing_date': 'Expected Billing Date',
    'accrued-revenue.label.entity_name': 'Entity',
    'accrued-revenue.label.revenue_account': 'Revenue Account',
    'accrued-revenue.label.accrued_receivable_account': 'Accrued Receivable Account',
    'accrued-revenue.label.currency': 'Currency',
    'accrued-revenue.label.amount': 'Amount',
    'accrued-revenue.label.description': 'Description',
    'accrued-revenue.label.reference_number': 'Reference Number',
    'accrued-revenue.label.memo': 'Memo',
    'accrued-revenue.label.auto_reverse': 'Auto Reverse',
    'accrued-revenue.label.reversal_date': 'Reversal Date',
    'accrued-revenue.label.accrual_number': 'Accrual Number',
    'accrued-revenue.label.accrued_revenue_account': 'Accrued Revenue Account',

    // Placeholders
    'accrued-revenue.placeholder.select_status': 'Select status',
    'accrued-revenue.placeholder.search': 'Search accrued revenues...',
    'accrued_revenues.search_placeholder': 'Search accrued revenues...',

    // Search
    'accrued-revenue.search.title': 'Search Accrued Revenues',
    'accrued-revenue.search.keyword': 'Keyword',
    'accrued-revenue.search.placeholder': 'Search accrued revenues...',

    // Filters
    'accrued_revenues.filters.status': 'Status',
    'accrued_revenues.filters.date_from': 'Date From',
    'accrued_revenues.filters.date_to': 'Date To',

    // Messages
    'accrued-revenue.message.created_successfully': 'Accrued revenue created successfully',
    'accrued_revenues.message.updated_successfully': 'Accrued revenue updated successfully',
    'accrued_revenues.validation.form_errors': 'Please correct the errors below',

    // Errors
    'accrued-revenue.error.message.error_loading_page': 'Sorry, there was an error loading the accrued revenue page.',
    'accrued-revenue.link.retry': 'Click here to retry',

    // Status
    'accrued_revenues.status.pending': 'Pending',
    'accrued_revenues.status.partial': 'Partial',
    'accrued_revenues.status.complete': 'Complete',
    'accrued_revenues.status.cancelled': 'Cancelled',
    'accrued_revenues.status.PENDING': 'Pending',
    'accrued_revenues.status.PARTIAL': 'Partial',
    'accrued_revenues.status.COMPLETE': 'Complete',
    'accrued_revenues.status.CANCELLED': 'Cancelled',
    'accrued-revenue.status.pending': 'Pending',
    'accrued-revenue.status.billed': 'Billed',
    'accrued-revenue.status.collected': 'Collected',
};
